/**
 * Branded types for type-safe identifiers.
 * Prevents accidental mixing of different ID types.
 */

declare const brand: unique symbol;

type Brand<T, B> = T & { readonly [brand]: B };

// Entity ID types
export type JobPositionId = Brand<string, 'JobPositionId'>;
export type CandidateId = Brand<string, 'CandidateId'>;
export type CompanyId = Brand<string, 'CompanyId'>;
export type UserId = Brand<string, 'UserId'>;
export type ApplicationId = Brand<string, 'ApplicationId'>;

// Type guards and constructors
export const JobPositionId = (id: string): JobPositionId => id as JobPositionId;
export const CandidateId = (id: string): CandidateId => id as CandidateId;
export const CompanyId = (id: string): CompanyId => id as CompanyId;
export const UserId = (id: string): UserId => id as UserId;
export const ApplicationId = (id: string): ApplicationId => id as ApplicationId;
